import styled from '@emotion/styled';
import { css } from '@emotion/react';

import {
    breakpoints,
    colorVariables,
    fontSizes,
    fontWeights,
    gutterSizes,
    lineHeights,
    mediaQuery,
} from '@gumtree/ui-library/src/base/theme';
import { newLayout } from '../../app.style';

export const Title = styled.h2`
    font-weight: ${fontWeights.bold};
    font-size: ${fontSizes.xlarge};
    line-height: ${lineHeights.xlarge};

    ${mediaQuery.from(breakpoints.large)} {
        font-size: ${fontSizes.pgLarge};
    }

    margin-bottom: ${gutterSizes.large};
    color: ${colorVariables.textPrimary};

    ${mediaQuery.between(breakpoints.medium, breakpoints.large)} {
        padding-top: 0;
    }
`;

export const SecondaryTitle = styled.h3<{ isMobileCardsLayout?: boolean }>`
    font-weight: ${fontWeights.bold};
    font-size: ${fontSizes.base};
    line-height: ${lineHeights.base};

    ${mediaQuery.from(breakpoints.large)} {
        margin-top: ${gutterSizes.xxlarge};
        margin-bottom: ${gutterSizes.large};
    }

    ${mediaQuery.until(breakpoints.large)} {
        margin-top: ${gutterSizes.xlarge};
        margin-bottom: ${gutterSizes.medium};
    }

    color: ${colorVariables.textPrimary};
`;

export const Container = styled.div<{ isMobileCardsLayout?: boolean }>`
    ${({ isMobileCardsLayout }) =>
        isMobileCardsLayout
            ? css`
                  ${newLayout}
                  ${css`
                      padding-bottom: ${gutterSizes.xlarge};
                  `}
              `
            : `margin-top: ${gutterSizes.xxlarge};`}
`;

export const AttributesContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    ${mediaQuery.until(breakpoints.large)} {
        grid-template-columns: 1fr;
    }
    row-gap: ${gutterSizes.base};
    column-gap: ${gutterSizes.xxlarge};
`;

export const AttributeCell = styled.div`
    display: flex;
    justify-content: left;
    align-items: self-start;
    min-width: 250px;
    gap: ${gutterSizes.medium};

    svg {
        min-width: ${lineHeights.base};
        width: ${lineHeights.base};
        height: ${lineHeights.base};
    }
`;

export const AttributeText = styled.span`
    line-height: ${lineHeights.base};
`;
